import type { App } from 'vue';
import {
    Badge, Button, Card, Cell, CellGroup, Grid, GridItem, Field, Col, Row, ActionSheet, Empty, Overlay,
    Icon, List, Loading, NavBar, Popup, Tabs, Tab, Lazyload,Image, SubmitBar, Form, Picker, RadioGroup, Radio,
    Popover,Notify, Toast
} from 'vant';

import 'vant/es/toast/style';
import 'vant/es/dialog/style';
import 'vant/es/notify/style';
import 'vant/es/image-preview/style';

import '@/styles/theme.css';

export function setupVant(app: App<Element>): void {
    app.use(Badge)
        .use(Button)
        .use(Card)
        .use(Cell)
        .use(CellGroup)
        .use(Grid)
        .use(GridItem)
        .use(Icon)
        .use(List)
        .use(Field)
        .use(Loading)
        .use(NavBar)
        .use(Popup)
        .use(Tabs)
        .use(Tab)
        .use(Lazyload)
        .use(SubmitBar)
        .use(Image)
        .use(Form)
        .use(Picker)
        .use(RadioGroup)
        .use(Radio)
        .use(Col)
        .use(Row)
        .use(ActionSheet)
        .use(Empty)
        .use(Overlay)
        .use(Popover)
        .use(Notify)
        .use(Toast)
    ;
}
